import { jsx as _jsx } from "react/jsx-runtime";
import { IconBellFilled, IconHomeFilled, IconQuestion, IconSearch, IconTakeatFilled, } from "../components/icons";
export var DEFAULT_THEME = {
    colors: {
        primary: {
            lightest: "#e5a1a4",
            lighter: "#db6e72",
            light: "#d13f45",
            default: "#c8131b",
            dark: "#94090f",
            darker: "#610206",
        },
        red: {
            lightest: "#e5a1a4",
            lighter: "#db6e72",
            light: "#d13f45",
            default: "#c8131b",
            dark: "#94090f",
            darker: "#610206",
        },
        yellow: {
            lightest: "#ffebc8",
            lighter: "#ffd894",
            light: "#ffc561",
            default: "#ffb32f",
            dark: "#cc8c1d",
            darker: "#99670f",
        },
        green: {
            lightest: "#bce3de",
            lighter: "#89d9cf",
            light: "#59cfc1",
            default: "#2ec9b7",
            dark: "#1d9688",
            darker: "#0f635a",
        },
        blue: {
            lightest: "#99dfff",
            lighter: "#66cfff",
            light: "#33bfff",
            default: "#01afff",
            dark: "#018ccc",
            darker: "#016999",
        },
        orange: {
            lightest: "#FFD8BD",
            lighter: "#FFB98A",
            light: "#FF9B57",
            default: "#FF7D24",
            dark: "#CC5F14",
            darker: "#994409",
        },
        second_green: {
            lightest: "#A5C7AF",
            lighter: "#77BD8B",
            light: "#4DB26A",
            default: "#27A84C",
            dark: "#167532",
            darker: "#0A421A",
        },
        neutral: {
            white: "#ffffff",
            lightest: "#f6f6f6",
            lighter: "#ededed",
            light: "#c6c6c6",
            default: "#7a7a7a",
            dark: "#545454",
            darker: "#222222",
            black: "#000000",
        },
    },
    shadows: {
        lighter: "0px 0px 2px 0px #0000001F, 0px 1px 2px 0px #00000024;",
        light: "0px 0px 2px 0px #0000001F, 0px 2px 4px 0px #00000024;",
        default: "0px 0px 2px 0px #0000001F, 0px 4px 8px 0px #00000024;",
        dark: "0px 0px 2px 0px #0000001F, 0px 8px 16px 0px #00000024;",
        darker: "0px 0px 8px 0px #00000033, 0px 10px 25px 0px #00000024;",
    },
    typography: {
        family: {
            default: '"Poppins", sans-serif',
        },
        weights: {
            regular: 400,
            medium: 500,
            semibold: 600,
            bold: 700,
        },
    },
    spacing: {
        xxs: "4px",
        xs: "8px",
        s: "16px",
        m: "24px",
        l: "32px",
        xl: "40px",
        xxl: "48px",
    },
    radius: {
        s: "4px",
        m: "8px",
        l: "12px",
        xl: "16px",
        xxl: "24px",
    },
    components: {
        fieldInfo: {
            fontSize: {
                desktop: "12px",
                tablet: "14px",
                totem: "16px",
            },
        },
        input: {
            label: {
                fontSize: {
                    desktop: "16px",
                    tablet: "18px",
                    totem: "20px",
                },
            },
            input: {
                fontSize: {
                    desktop: "14px",
                    tablet: "16px",
                    totem: "18px",
                },
                height: {
                    desktop: "40px",
                    tablet: "48px",
                    totem: "56px",
                },
                borderRadius: {
                    desktop: "8px",
                    tablet: "12px",
                    totem: "16px",
                },
                padding: {
                    desktop: "10px 16px",
                    tablet: "12px 16px",
                    totem: "16px 12px",
                },
            },
        },
        button: {
            fontSize: {
                desktop: "14px",
                tablet: "16px",
                totem: "18px",
            },
            height: {
                desktop: "40px",
                tablet: "48px",
                totem: "56px",
            },
            padding: {
                desktop: "0 16px",
                tablet: "0 24px",
                totem: "0 32px",
            },
        },
    },
    device: "desktop",
};
// Usado em alguns componentes como Switch e Radio Button
export var LABEL_POSITIONS = {
    top: "column",
    bottom: "column-reverse",
    left: "row",
    right: "row-reverse",
};
export var MENU_ITEMS = [
    {
        id: "filler-1",
        filler: true,
        height: 50,
        text: "",
        path: "",
    },
    {
        id: "1",
        text: "Home",
        path: "/",
        icon: _jsx(IconHomeFilled, {}),
    },
    {
        id: "search-1",
        icon: _jsx(IconSearch, {}),
        text: "Buscar",
        path: "#",
    },
    {
        id: "filler-2",
        filler: true,
        height: 50,
        text: "",
        path: "",
    },
    {
        id: "2",
        text: "About",
        path: "/about",
        icon: _jsx(IconQuestion, {}),
        external: "https://google.com",
    },
    {
        id: "3",
        text: "Services",
        path: "/services",
        icon: _jsx(IconBellFilled, {}),
        subitems: [
            {
                id: "3-1",
                text: "Relatórios",
                path: "/reports",
                subitems: [
                    {
                        id: "3-1-1",
                        text: "Geral",
                        path: "/general",
                    },
                    {
                        id: "3-1-2",
                        text: "Cadastros",
                        path: "/registers",
                    },
                    {
                        id: "3-1-3",
                        text: "Aniversariantes",
                        path: "/birthdays",
                    },
                    {
                        id: "3-1-4",
                        text: "Plano de contas (Centro de custos)",
                        path: "/products",
                    },
                ],
            },
            {
                id: "3-2",
                text: "Cashback",
                path: "/cashback",
                subitems: [
                    {
                        id: "3-2-1",
                        text: "Relatórios",
                        path: "/reports",
                    },
                    {
                        id: "3-2-2",
                        text: "Configurações",
                        path: "/settings",
                    },
                ],
            },
            {
                id: "3-3",
                text: "TakeUp",
                path: "/takeup",
                subitems: [
                    {
                        id: "3-3-1",
                        text: "Relatórios",
                        path: "/reports",
                    },
                    {
                        id: "3-3-2",
                        text: "Campanhas",
                        path: "/campaigns",
                    },
                ],
            },
        ],
    },
    {
        id: "4",
        text: "Clube",
        path: "/club",
        icon: _jsx(IconTakeatFilled, {}),
        subitems: [
            {
                id: "4-1",
                text: "Relatórios",
                path: "/reports",
                subitems: [
                    {
                        id: "4-1-1",
                        text: "Geral",
                        path: "/general",
                    },
                    {
                        id: "4-1-2",
                        text: "Cadastros",
                        path: "/registers",
                    },
                    {
                        id: "4-1-3",
                        text: "Aniversariantes",
                        path: "/birthdays",
                    },
                    {
                        id: "4-1-4",
                        text: "Produtos",
                        path: "/products",
                    },
                ],
            },
            {
                id: "4-2",
                text: "Cashback",
                path: "/cashback",
                subitems: [
                    {
                        id: "4-2-1",
                        text: "Relatórios",
                        path: "/reports",
                    },
                    {
                        id: "4-2-2",
                        text: "Configurações",
                        path: "/settings",
                    },
                ],
            },
            {
                id: "4-3",
                text: "TakeUp",
                path: "/takeup",
                subitems: [
                    {
                        id: "4-3-1",
                        text: "Relatórios",
                        path: "/reports",
                    },
                    {
                        id: "4-3-2",
                        text: "Campanhas",
                        path: "/campaigns",
                    },
                ],
            },
            {
                id: "4-4",
                text: "Teste",
                path: "/test",
            },
        ],
    },
];
//# sourceMappingURL=consts.js.map